import React, { SyntheticEvent, useCallback } from 'react';
import SpinnerIconButton from 'Components/Link/SpinnerIconButton';
import Menu from 'Components/Menu/Menu';
import MenuContent from 'Components/Menu/MenuContent';
import MenuItem from 'Components/Menu/MenuItem';
import { icons } from 'Helpers/Props';

export interface ActivityAction { key: string; label: string; isDisabled?: boolean }

export default function ActivityActionMenu({ actions, isSpinning, onAction }: { actions: ActivityAction[]; isSpinning: boolean; onAction: (action: string) => void }) {
  const onPress = useCallback((event: SyntheticEvent) => {
    const action = event.currentTarget.getAttribute('data-action');
    if (action) onAction(action);
  }, [onAction]);
  return <Menu alignMenu="right">
    <SpinnerIconButton name={icons.ACTIONS} isSpinning={isSpinning} isDisabled={isSpinning} aria-label="Actions" />
    <MenuContent>{actions.map((action) => <MenuItem key={action.key} data-action={action.key} isDisabled={action.isDisabled} onPress={onPress}>{action.label}</MenuItem>)}</MenuContent>
  </Menu>;
}
